import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Heading from "../../../components/shared/Heading/Heading";
import { cleanUpPage, setGenresValue } from "../../../store/slices/lists.slice";
import { ROUTES } from "../../../constants/routes";
import styles from "../styles/Details.module.scss";

const EXCLUDED_GENRE_IDS = [99]; // Documentary — not available in feed

interface Genre {
  pk?: number;
  id?: number;
  name: string;
}

interface Props {
  genres: Genre[];
}

const MovieGenres = ({ genres }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!genres?.length) return null;

  const filteredGenres = genres.filter((genre) => {
    const genreId = genre.pk ?? genre.id;
    return genreId != null && !EXCLUDED_GENRE_IDS.includes(genreId);
  });

  if (!filteredGenres.length) return null;

  const handleGenreClick = (genreId: number) => {
    dispatch(cleanUpPage());
    dispatch(setGenresValue([genreId]));
    navigate(ROUTES.SEARCH);
  };

  return (
    <div className={styles.movieGenresSection}>
      <Heading title={t("movieGenres")} counter={String(filteredGenres.length)} />
      <div className={styles.movieGenresChips}>
        {filteredGenres.map((genre) => {
          const genreId = (genre.pk ?? genre.id)!;
          return (
            <div
              key={genreId}
              className={styles.movieGenreChip}
              onClick={() => handleGenreClick(genreId)}
            >
              {t(genre.name)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MovieGenres;
